import PropTypes from 'prop-types';

import { HomeCheckerShape } from '@spotahome/ui-library/src/tenant/shapes/HomeChecker';
import {
  LandlordScoringShape,
  RnaIdFeatureShape
} from '@spotahome/ui-library/src/tenant/constants/shapes';

import instantBookingShape from '@spotahome/marketplace-common/src/shapes/instantBooking';

import './PropertyTitle.scss';

import SimplifiedPropertyTitle from './SimplifiedPropertyTitle';
import PropertyTitleLabelsSection from './PropertyTitleLabelsSection';

const EMPTY_OBJECT = {};

const PropertyTitle = ({
  title,
  type,
  details,
  cityId,
  isBestChoice,
  plan,
  bills = EMPTY_OBJECT,
  isChecked,
  instantBooking = EMPTY_OBJECT,
  allowsPermanentContract = false,
  homechecker = null,
  verificationDate = null,
  landlordType,
  landlordId,
  listingId,
  countryCode,
  statistics = EMPTY_OBJECT,
  landlordScoring = EMPTY_OBJECT,
  rnaIdFeature = null
}) => (
  <div className="property-title property-title--compact">
    <SimplifiedPropertyTitle title={title} type={type} details={details} />
    <PropertyTitleLabelsSection
      cityId={cityId}
      isBestChoice={isBestChoice}
      plan={plan}
      bills={bills}
      isChecked={isChecked}
      instantBooking={instantBooking}
      allowsPermanentContract={allowsPermanentContract}
      homechecker={homechecker}
      verificationDate={verificationDate}
      landlordType={landlordType}
      landlordId={landlordId}
      listingId={listingId}
      countryCode={countryCode}
      statistics={statistics}
      landlordScoring={landlordScoring}
      rnaIdFeature={rnaIdFeature}
    />
  </div>
);

PropertyTitle.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  details: PropTypes.shape({
    nBedrooms: PropTypes.number,
    nBathrooms: PropTypes.number,
    m2: PropTypes.number
  }).isRequired,
  cityId: PropTypes.string.isRequired,
  isBestChoice: PropTypes.bool.isRequired,
  plan: PropTypes.string.isRequired,
  bills: PropTypes.shape({
    [PropTypes.number]: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  }),
  isChecked: PropTypes.bool.isRequired,
  instantBooking: PropTypes.shape(instantBookingShape),
  allowsPermanentContract: PropTypes.bool,
  homechecker: PropTypes.shape(HomeCheckerShape),
  verificationDate: PropTypes.string,
  landlordType: PropTypes.oneOf(['professional', 'private']).isRequired,
  landlordId: PropTypes.string.isRequired,
  listingId: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  statistics: PropTypes.shape({
    visited: PropTypes.number,
    shared: PropTypes.number,
    favorite: PropTypes.number,
    interested: PropTypes.number
  }),
  landlordScoring: PropTypes.shape(LandlordScoringShape),
  rnaIdFeature: PropTypes.shape(RnaIdFeatureShape)
};

export default PropertyTitle;
